import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";


import AdministrativeJobAdminPanel from "./AdministrativeJobAdminPanel";
import AdministrativeSelectionJobAdminPanel from "./AdministrativeSelectionJobAdminPanel";
import AdministrativeAdmitCardAdminPanel from "./AdministrativeAdmitCardAdminPanel";
import AdministrativeResultAdminPanel from "./AdministrativeResultAdminPanel";
import AdministrativeAnswerKeyAdminPanel from "./AdministrativeAnswerKeyAdminPanel";
import AdministrativeSyllabusAdminPanel from "./AdministrativeSyllabusAdminPanel";
import AdministrativeAdmissionAdminPanel from "./AdministrativeAdmissionAdminPanel";
import AdministrativeEligibilityAdminPanel from "./AdministrativeEligibilityAdminPanel";
import "../superadmin/AdminPanel.css";


function AdministrativeAdminPanel() {
   const [selectedPanel, setSelectedPanel] = useState("");
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const navigate = useNavigate();

  // Sync with global dark mode (Navbar)
  React.useEffect(() => {
    // Sync dark mode state from localStorage and apply CSS vars/body class
    const syncDarkMode = () => {
      const isDark = localStorage.getItem('darkMode') === 'true';
      setDarkMode(isDark);
      if (isDark) {
        document.documentElement.style.setProperty('--bg-primary', '#0f172a');
        document.documentElement.style.setProperty('--bg-secondary', '#1a1a2e');
        document.documentElement.style.setProperty('--text-primary', '#f1f5f9');
        document.documentElement.style.setProperty('--text-secondary', '#cbd5e1');
        document.documentElement.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.1)');
        document.documentElement.style.setProperty('--accent-color', '#60a5fa');
        document.body.classList.add('dark-mode');
      } else {
        document.documentElement.style.setProperty('--bg-primary', '#ffffff');
        document.documentElement.style.setProperty('--bg-secondary', '#f8f9fa');
        document.documentElement.style.setProperty('--text-primary', '#1f2937');
        document.documentElement.style.setProperty('--text-secondary', '#475569');
        document.documentElement.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.06)');
        document.documentElement.style.setProperty('--accent-color', '#3b82f6');
        document.body.classList.remove('dark-mode');
      }
    };
    syncDarkMode();
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);

   const token = localStorage.getItem("token");
  if (!token) {
    return (
      <div className="admin-panel-error">❌ No token found! Please login first.</div>
    );
  }

    // Role-based protection
    const role = localStorage.getItem("role");
    if (role !== "administrative") {
      return <Navigate to="/administrative-login" replace />;
    }
 
  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/administrative-login", { state: { popupType: "success", popupMessage: "Logged out successfully" }, replace: true });
  };

  

  // Sidebar menu items for administrative admin
  const menu = [
    { key: "job", label: "Administrative Job Management", component: <AdministrativeJobAdminPanel darkMode={darkMode} /> },
    { key: "selection", label: "Administrative Selection Job Detail", component: <AdministrativeSelectionJobAdminPanel darkMode={darkMode} /> },
    { key: "admitCard", label: "Administrative Admit Card", component: <AdministrativeAdmitCardAdminPanel darkMode={darkMode} /> },
    { key: "result", label: "Administrative Result", component: <AdministrativeResultAdminPanel darkMode={darkMode} /> },
    { key: "answerKey", label: "Administrative Answer Key", component: <AdministrativeAnswerKeyAdminPanel darkMode={darkMode} /> },
    { key: "syllabus", label: "Administrative Syllabus", component: <AdministrativeSyllabusAdminPanel darkMode={darkMode} /> },
    { key: "admission", label: "Administrative Admission", component: <AdministrativeAdmissionAdminPanel darkMode={darkMode} /> },
    { key: "eligibility", label: "Administrative Eligibility", component: <AdministrativeEligibilityAdminPanel /> },
  ];

  return (
    <>
      <div className={`admin-panel${darkMode ? " dark-mode" : ""}`}> 
        <div className="admin-panel-topbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5rem' }}>
            <h2 style={{ margin: 0 }}>Administrative Admin Panel</h2>
            <button 
              className="theme-toggle" 
              style={{ 
                background: darkMode ? '#0f2561' : '#f3f4f6',
                border: darkMode ? '1px solid #e0e6f0' : '1px solid #232836',
                borderRadius: 6,
                padding: 4, 
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'border-radius 0.15s',
              }}
              onMouseDown={e => e.currentTarget.style.borderRadius = '50%'}
              onMouseUp={e => e.currentTarget.style.borderRadius = '6px'}
              onMouseLeave={e => e.currentTarget.style.borderRadius = '6px'}
              onClick={() => {
                const newMode = !darkMode;
                setDarkMode(newMode);
                localStorage.setItem('darkMode', newMode ? 'true' : 'false');
                if (newMode) {
                  document.documentElement.style.setProperty('--bg-primary', '#0f172a');
                  document.documentElement.style.setProperty('--bg-secondary', '#1a1a2e');
                  document.documentElement.style.setProperty('--text-primary', '#f1f5f9');
                  document.documentElement.style.setProperty('--text-secondary', '#cbd5e1');
                  document.documentElement.style.setProperty('--border-color', 'rgba(255, 255, 255, 0.1)');
                  document.documentElement.style.setProperty('--accent-color', '#60a5fa');
                  document.body.classList.add('dark-mode');
                } else {
                  document.documentElement.style.setProperty('--bg-primary', '#ffffff');
                  document.documentElement.style.setProperty('--bg-secondary', '#f8f9fa');
                  document.documentElement.style.setProperty('--text-primary', '#1f2937');
                  document.documentElement.style.setProperty('--text-secondary', '#475569');
                  document.documentElement.style.setProperty('--border-color', 'rgba(0, 0, 0, 0.06)');
                  document.documentElement.style.setProperty('--accent-color', '#3b82f6');
                  document.body.classList.remove('dark-mode');
                }
                window.dispatchEvent(new Event('darkModeChanged'));
              }}
              title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              {darkMode ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#e0e6f0' }}>
                  <circle cx="12" cy="12" r="5"></circle>
                  <line x1="12" y1="1" x2="12" y2="3"></line>
                  <line x1="12" y1="21" x2="12" y2="23"></line>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                  <line x1="1" y1="12" x2="3" y2="12"></line>
                  <line x1="21" y1="12" x2="23" y2="12"></line>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ color: '#232836' }}>
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                </svg>
              )}
            </button>
          </div>
          <div className="admin-panel-topbar-actions">
            <button onClick={handleLogout} className="admin-logout-btn">Logout</button>
          </div>
        </div>
        <div className="admin-panel-main">
          <div className="admin-sidebar">
            <nav>
              {menu.map((item) => (
                <button
                  key={item.key}
                  className={selectedPanel === item.key ? "selected" : ""}
                  onClick={() => setSelectedPanel(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="admin-content">
            {selectedPanel ? (
              menu.find((item) => item.key === selectedPanel)?.component
            ) : (
              <div className="admin-panel-placeholder">
                👈 Please select a panel from the menu.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AdministrativeAdminPanel;
